import React from 'react';
import Welcome from './Welcome';
import { useNavigationContext } from '../../../contexts/NavigationContext';
import Navbar from '../common/navbar/Navbar';
import EventPage from './Events/EventPage';
import NewsPage from './News/NewsPage';
import FilesPage from './Files/FilesPage';
import HighlightPage from './Highlight/HighlightPage';
import DatePage from './Date/DatePage';
import './BasseCour.scss';
import PillsPage from './Pills/PillsPage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <div className="flex flex-row h-screen w-screen">
      <div className="min-w-64 w-64">
        <Navbar />
      </div>
      <div className="w-full h-auto overflow-scroll">
        <EventPage isActive={navigationContext.acitveAppKey === 'qbevent'} />
        <NewsPage isActive={navigationContext.acitveAppKey === 'qbnews'} />
        <HighlightPage isActive={navigationContext.acitveAppKey === 'qbhighlight'} />
        <DatePage isActive={navigationContext.acitveAppKey === 'qbdate'} />
        <FilesPage isActive={navigationContext.acitveAppKey === 'qbfiles'} />
        <PillsPage isActive={navigationContext.acitveAppKey === 'qbpills'} />
        <Welcome isActive={!navigationContext.acitveAppKey} />
      </div>
    </div>
  );
}

export default Home;
